import { Component, OnInit, ChangeDetectionStrategy, input, output, inject } from '@angular/core';
import { Router } from '@angular/router';
import { GenericMenuItem } from '../generic-menu/generic-menu-item.model';
import { BaseComponent } from '@app/shared/base/components/base-component';
import { __ } from '@app/shared/functions/object.functions';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'hypecast-master-admin-generic-actions',
  templateUrl: './generic-actions.component.html',
  styleUrls: ['./generic-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButton, MatProgressSpinner],
})
export class GenericActionsComponent extends BaseComponent implements OnInit {
  private router = inject(Router);

  actions: GenericMenuItem[] = [];

  readonly item = input<unknown>(undefined);

  readonly items = input<GenericMenuItem[]>([]);

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  readonly onItemClicked = output<GenericMenuItem>();

  ngOnInit() {
    this.actions = this.items();
  }

  /**
   * The callback when a menu item was clicked. Executes up to three handling actions:
   * 1. Emits the clicked menu item
   * 2. Navigates to a provided route
   * 3. Opens a dialog using the provided open dialog method
   *
   * @memberof GenericMenuComponent
   */
  itemClick(menuItem: GenericMenuItem): void {
    if (!__.IsNullOrUndefined(menuItem.actionType)) {
      this.onItemClicked.emit(menuItem);
    }
    if (!__.IsNullOrUndefined(menuItem.routerLink)) {
      this.router.navigate([menuItem.routerLink]);
    }
    if (!__.IsNullOrUndefined(menuItem.execute)) {
      menuItem.execute.call(__.IsNullOrUndefined(menuItem.context) ? this : menuItem.context);
    }
  }

  checkDisabled(menuItem: GenericMenuItem) {
    if (typeof menuItem.disabled === typeof true) {
      return menuItem.disabled;
    }
    if (this.isFunction(menuItem.disabled)) {
      return (menuItem.disabled as (...args: unknown[]) => boolean).call(
        __.IsNullOrUndefined(menuItem.context) ? this : menuItem.context,
        this.item(),
      );
    }
    return true;
  }

  checkIsLoading(menuItem: GenericMenuItem) {
    if (typeof menuItem.isLoading === typeof true) {
      return menuItem.isLoading;
    }
    if (this.isFunction(menuItem.isLoading)) {
      return (menuItem.isLoading as (...args: unknown[]) => boolean).call(
        __.IsNullOrUndefined(menuItem.context) ? this : menuItem.context,
        this.item(),
      );
    }
    return false;
  }

  checkIsVisible(menuItem: GenericMenuItem) {
    if (typeof menuItem.visible === typeof true) {
      return menuItem.visible;
    }
    if (this.isFunction(menuItem.visible)) {
      return (menuItem.visible as (...args: unknown[]) => boolean).call(
        __.IsNullOrUndefined(menuItem.context) ? this : menuItem.context,
        this.item(),
      );
    }
    return false;
  }

  private isFunction(functionToCheck: unknown) {
    return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
  }
}
